// The scenario page's own detail shard (data/scenarios/<id>.json): phases,
// line items, the national spread and the DRG bundle. One cached loader
// shared by the scenario card block and the "What's in it" row.
import { loadStaticData } from "./staticData";

export interface DetailProcedure {
  code: string; codeType: string; description?: string | null; consumerName?: string | null;
  phase?: string | null; quantity?: number | null; dayNumber?: number | null; setting?: string | null;
}
export interface ScenarioDetail {
  id: string; name: string; slug?: string;
  description?: string | null; iconName?: string | null; color?: string | null; duration?: string | null;
  totalProcedures?: number | null;
  phases?: string[];
  procedures?: DetailProcedure[];
  phaseBreakdown?: Record<string, number>;
  phaseBreakdownMedian?: Record<string, number> | null;
  phaseBreakdownRaw?: Record<string, number> | null;
  estimatedCost?: number | null; estimatedCostMedian?: number | null; estimatedCostRaw?: number | null;
  p10Cost?: number | null; p90Cost?: number | null;
  drgInpatient?: { cornerstone: string; cornerstoneType: string; drgFamily: string[]; baseDrg: string; baseDrgTitle?: string | null; coversPhases?: string[] } | null;
}

const cache = new Map<string, Promise<ScenarioDetail | null>>();
export function loadScenarioDetail(id: string): Promise<ScenarioDetail | null> {
  if (!cache.has(id)) cache.set(id, loadStaticData<{ data: ScenarioDetail }>(`scenarios/${id}.json`).then((d) => d?.data ?? null).catch(() => null));
  return cache.get(id)!;
}

/** Phases paid inside the single inpatient DRG price (never itemised as $0). */
export function bundledPhases(detail: ScenarioDetail): Set<string> {
  const procs = detail.procedures ?? [];
  const drgLines = procs.filter((p) => (p.codeType || "").toUpperCase() === "DRG");
  if (drgLines.length === 0) return new Set();
  const declared = detail.drgInpatient?.coversPhases;
  return new Set(declared?.length ? declared : drgLines.map((p) => p.phase || "").filter(Boolean));
}
